module.exports = __webpack_public_path__ + "static/media/ic_freehand.3cd9ca72.svg";